import { createSlice } from '@reduxjs/toolkit';
import {
  ASYNC_REQUEST,
  ASYNC_REQUEST_COMPLETE,
  ASYNC_REQUEST_ERROR,
  ASYNC_REQUEST_UPDATE_SUCCESS,
  ASYNC_REQUEST_ACTION_FAILED,
  ASYNC_REQUEST_CLEAR_STATUS
} from '../constants/constants';
import { SERVER_FAILURE_ERROR } from '../constants/messages';

const initialState = {
  requestActive: false,
  updateSuccess: false,
  updateFailed: false,
  error: false,
  errMsg: ''
};

const asyncActionSlice = createSlice({
  name: 'asyncAction',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(ASYNC_REQUEST, state => {
        state.requestActive = true;
        state.error = false;
        state.errMsg = '';
      })
      .addCase(ASYNC_REQUEST_COMPLETE, state => {
        state.requestActive = false;
        state.error = false;
        state.errMsg = '';
      })
      .addCase(ASYNC_REQUEST_ERROR, (state, action) => {
        state.requestActive = false;
        state.error = true;
        state.errMsg = action.errMsg;
      })
      .addCase(ASYNC_REQUEST_UPDATE_SUCCESS, state => {
        state.updateSuccess = true;
        state.updateFailed = false;
      })
      .addCase(ASYNC_REQUEST_ACTION_FAILED, (state, action) => {
        state.updateSuccess = false;
        state.updateFailed = true;
        state.errMsg = action.errMsg || { error: SERVER_FAILURE_ERROR };
      })
      .addCase(ASYNC_REQUEST_CLEAR_STATUS, () => initialState);
  }
});

export default asyncActionSlice.reducer;
